import { Fragment } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "./Alert";
import React from "react";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const SnackAlert = ({ handler, ...props }) => {
  const { alert, closeAlert } = handler;
  const { action } = props;

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={alert.open}
      autoHideDuration={6000}
      onClose={() => closeAlert()}
    >
      <Alert
        onClose={() => closeAlert()}
        severity={alert.severity}
        action={
          <Fragment>
            {alert.showAction && action}
            <IconButton
              size="small"
              style={{ color: "white" }}
              onClick={() => closeAlert()}
            >
              <CloseIcon />
            </IconButton>
          </Fragment>
        }
      >
        {alert.messages &&
          alert.messages.map(message => (
            <div key={Math.random()}>{message}</div>
          ))}
      </Alert>
    </Snackbar>
  );
};

export default SnackAlert;
